<template>
  <div>
  <div style="text-align: center;top: 0;position: absolute;width: 90%;" class="hidden-sm-and-up mb-4">
    <div class="red--text text--darken-2 subheading pt-2" v-if="settlement">Please wait&hellip;</div>
    <button class="btn btn-light waves-effect waves-light" style="float:left;" @click="goBack">Back</button>
    <button class="btn btn-success waves-effect waves-light" style="float:right;" ref="mobileSubmit" :disabled="loading">Pay now</button>
  </div>
    <div class="payment pt-5">
      <div ref="dropin"></div>
      <div style="text-align: center;" class="hidden-xs-only">
        <div class="red--text text--darken-2 subheading pt-2" v-if="settlement">Please wait&hellip;</div>
        <button class="btn btn-light waves-effect waves-light" style="float:left;" @click="goBack">Back</button>
        <button class="btn btn-success waves-effect waves-light" style="float:right;" ref="submit" :disabled="loading">Pay now</button>
      </div>
    </div>
  </div>
</template>

<script>
  import dropIn from 'braintree-web-drop-in'
  import axios from 'axios'

  export default {
    props: {
      token: {
        required: true,
        type: String
      },
      locale: {
        type: String,
        default: 'en_US'
      },
      paypal: {
        type: Boolean,
        default: false
      },
      userId: {
        type: Number,
        default: -1
      },
      orderId: {
        type: Number,
        default: -1
      },
      amount: {
        type: Number,
        default: -1
      }
    },
    computed: {
      cognetiToken () {
        return this.$store.getters['token']
      },
      transactionSuccessful: {
        get: function () {
          return this.$store.getters['braintree/getTransactionSuccessful']
        },
        set: function (status) {
          this.$store.commit('braintree/setTransactionSuccessful', status)
        }
      }
    },
    data () {
      return {
        settlement: false,
        url: process.env.API_URL + `/ws/checkout/order/payment`,
        loading: true, // When a payment is processed, prevents double clicks
        disabled: false // When a payment is successfully processed, the entire component is disabled
      }
    },
    mounted () {
      var vm = this
      this.$store.commit('braintree/setTransactionSuccessful', false)
      this.settlement = false
      // Create config
      let config = {
        authorization: this.token,
        container: this.$refs.dropin,
        locale: this.locale
      }

      // If Paypal is available
      if (this.paypal) {
        config.paypal = {
          flow: 'vault'
        }
      }

      // Create dropin
      dropIn.create(config, function (createErr, instance) {
        vm.$emit('loaded')
        vm.loading = false
        vm.$refs.submit.addEventListener('click', function () {
          if (!vm.loading && !vm.disabled) {
            instance.requestPaymentMethod(function (err, payload) {
              if (err) {
                // No payment method is available.
                // An appropriate error will be shown in the UI.
                console.error(err)
                return
              }
              vm.loading = true
              vm.pay(payload.nonce)
            })
          }
        })
        vm.$refs.mobileSubmit.addEventListener('click', function () {
          if (!vm.loading && !vm.disabled) {
            instance.requestPaymentMethod(function (err, payload) {
              if (err) {
                // No payment method is available.
                // An appropriate error will be shown in the UI.
                console.error(err)
                return
              }
              vm.loading = true
              vm.pay(payload.nonce)
            })
          }
        })
      })
    },
    destroyed () {
      // this.$refs.submit.removeEventListenter('click')
    },
    methods: {
      goBack () {
        this.$store.commit('braintree/setClientToken', 0)
      },
      pay (nonce) {
        let data = {
          userId: this.userId,
          pmNonce: nonce,
          orderId: this.orderId,
          amount: this.amount,
          paymentMethod: 0,
          payPalAccount: null
        }
        this.settlement = true
        axios({
          url: this.url,
          method: 'POST',
          data,
          headers: {
            Authorization: 'Bearer ' + this.cognetiToken
          }
        }).then(response => {
          this.$store.commit('flashSuccess', 'Congratulations, payment has been done.', { root: true })
          this.$store.commit('braintree/setTransactionId', response.data.transactionId)
          this.$store.commit('braintree/setTransactionSuccessful', true)
          this.loading = false
          this.disabled = true
          this.settlement = false
        }).catch(error => {
          this.$store.commit('braintree/setTransactionSuccessful', false)
          this.$store.commit('flashError', error.response.data, { root: true })
          this.loading = false
        })
      }
    }
  }
</script>
<style>
  .btn-success.disabled, .btn-success:disabled {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
  }
  .btn.disabled, .btn:disabled {
    opacity: .65;
  }
  .btn-success {
    background-color: #00c851!important;
    color: #fff!important;
  }

  .waves-effect {
    position: relative;
    cursor: pointer;
    overflow: hidden;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
  }
  .btn-success:not([disabled]):not(.disabled).active, .btn-success:not([disabled]):not(.disabled):active, .show>.btn-success.dropdown-toggle {
    box-shadow: 0 5px 11px 0 rgba(0,0,0,.18), 0 4px 15px 0 rgba(0,0,0,.15);
    background-color: #006228!important;
  }
  .btn-success:not(:disabled):not(.disabled).active, .btn-success:not(:disabled):not(.disabled):active, .show>.btn-success.dropdown-toggle {
    color: #fff;
    background-color: #1e7e34;
    border-color: #1c7430;
  }
  .btn.btn-lg {
    padding: 1rem 2.4rem;
    font-size: .94rem;
  }
  .btn:active, .btn:focus, .btn:hover {
    outline: 0;
    box-shadow: 0 5px 11px 0 rgba(0,0,0,.18), 0 4px 15px 0 rgba(0,0,0,.15);
  }
  .btn-light:hover {
    background-color: #ededed;
    color: #000;
  }
  .btn:active, .btn:focus, .btn:hover {
    outline: 0;
    box-shadow: 0 5px 11px 0 rgba(0,0,0,.18), 0 4px 15px 0 rgba(0,0,0,.15);
  }
  .btn-light:hover {
    color: #212529;
    background-color: #e2e6ea;
    border-color: #dae0e5;
  }
  .btn-light {
    background-color: #e0e0e0!important;
    color: #000;
  }
  .btn {
    margin: .375rem;
    color: inherit;
    text-transform: uppercase;
    word-wrap: break-word;
    white-space: normal;
    cursor: pointer;
    border: 0;
    border-radius: .125rem;
    box-shadow: 0 2px 5px 0 rgba(0,0,0,.16), 0 2px 10px 0 rgba(0,0,0,.12);
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    padding: .74rem 2.14rem;
    font-size: .91rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/widgets/Payment.vue